import { Component, OnInit, inject } from '@angular/core';
import { IUsuario } from 'modelos/src';
import { AuthService } from '../../login/auth.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  standalone: false,
})
export class LandingComponent implements OnInit {
  private authService = inject(AuthService);

  public user?: IUsuario;

  async ngOnInit(): Promise<void> {
    this.user = this.authService.getUsuario();
  }
}
